import { List } from "immutable";
import * as React from "react";
import { HttpResult } from "widgets-for-react";
import { partition } from "../../../../Shared/utils/list";
import { library } from "../../../libraries";
import { Loader } from "../loader";
import { loadFormstackForm } from "./formstack_api";
import { FormstackForm } from "./formstack_types";

export type FormstackBlockProps = {
  readonly kind: "formstack_block"
  formId: string
}

export type FormstackBlockState = {
  form: HttpResult<FormstackForm>
}

const initialState: FormstackBlockState = {
  form: { kind: null, status: null }
}


export type FormstackBlockStyle = Partial<{
  blockClassName: string
  innerClassName: string
  headerClassName: string
  titleClassName: string
  contentClassName: string
}>

export const formstackBlockClasses: FormstackBlockStyle = {
  blockClassName: 'block block--form container--sg align--center',
  innerClassName: 'block__inner',
  contentClassName: 'block__content'
}


let isMounted = false
let previousFormHeight = -1

export class InnerHTML extends React.Component<{ html: string }, {}> {
  constructor(prop) {
    super(prop)
    this.state = {}
    isMounted = true
    previousFormHeight = -1
  }

  componentWillUnmount() {
    isMounted = false
  }


  render() {
    return <div
      ref={async (divRef) => {
        if (!this.props.html || !divRef || (divRef && divRef.innerHTML != '')) return

        divRef.innerHTML = '' // Clear the container

        var targetDiv = document.createElement('div')

        var parsedDocument = new DOMParser().parseFromString(this.props.html, "text/html");
        var body = parsedDocument.getElementById('fsLocal')

        // Insert classname if necessary below
        targetDiv.className = body.className + " example-classname"
        targetDiv.id = body.id
        targetDiv.innerHTML = body.innerHTML

        const links = List<HTMLLinkElement>(parsedDocument.getElementsByTagName('link')).filter(link => !link.href.includes('light.css'))

        const promises = links
          .map(link => new Promise<string>((resolve) => link.onload = () => resolve(link.href)))
          .toArray()
        links.forEach(link => divRef.appendChild(link))

        // Prepare copy of live Element list
        const copy_scripts: List<HTMLScriptElement> = List(targetDiv.getElementsByTagName('script'))

        // Remove scripts from initial html (done by reference)
        copy_scripts.forEach(x => x.remove())

        // When all external CSS has loaded, add the processed form div to the DOM
        await Promise.all(promises)
          .then(() => divRef.appendChild(targetDiv))

        // Load the scripts, first external then inline scripts
        const [linkedScripts, inlineScripts] = partition(copy_scripts, x => x.src && x.src.length > 1)

        const scriptLoaders = linkedScripts.map((x) => new Promise((resolve, reject) => {
          const s = document.createElement('script')
          s.src = x.src
          s.async = false
          s.onload = (_) => resolve(s.src)
          s.onerror = (_) => reject(s.src)
          divRef.firstChild.appendChild(s)
        })).toArray()

        // Wait for external scripts to load
        await Promise.all(scriptLoaders)
          .catch((src) => console.error("failed to load", src))

        // Append inline scripts
        inlineScripts.forEach(x => {
          const s = document.createElement('script')
          s.text = x.text
          divRef.firstChild.appendChild(s)
        })

        // Execute formstack library function to initialize form
        window.loadFormstack()


        // Scrolling logic
        // let checkHeight = () => setTimeout(() => {
        //   if (!isMounted) return
        //   let formDiv: HTMLElement = document.querySelector('#fsLocal')
        //   let currentHeight = formDiv.offsetHeight
        //   if (previousFormHeight == -1) { previousFormHeight = currentHeight }

        //   if (previousFormHeight != currentHeight) {
        //     // scrollTo
        //     formDiv.scrollIntoView(false)
        //   }
        //   previousFormHeight = currentHeight
        //   checkHeight()
        // }, 500)
        // checkHeight()
      }
      }
    ></div>
  }
}

export class FormstackBlock extends React.Component<FormstackBlockProps, FormstackBlockState> {
  constructor(props) {
    super(props)
    this.state = initialState
  }

  componentDidMount() {
    loadFormstackForm(this.props.formId).then((result) =>
      this.setState((prevState) => ({ ...prevState, form: result }))
    )
  }

  render() {
    const form = this.state.form
    const copy = library().copy.forms
    let formEl: JSX.Element;

    switch (form.kind) {
      case "failed":
      case "unauthorized": {
        formEl = <div className="form form--formstack form--formstack-failed">{copy.loadingFailed}</div>
        break;
      }
      case "result": {
        formEl = <div className="form form--formstack form--formstack-loaded"><InnerHTML html={form.value.html} /></div>
        break;
      }
      default: {
        formEl = <div className="form form--formstack form--formstack-loading">
          Het formulier wordt geladen...
          <Loader />
        </div>
      }
    }

    return (
      <>
        <section className="block block--form container--sg align--center">
          <div className="block__inner">
            <div className="block__content">
              {formEl}
            </div>
          </div>
        </section>
        <hr />
      </>
    )
  }
}